/**
 * @flow
 * @relayHash bed4fbcfef7c446f9f2f7eb45e96bdef
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HttpWithinHttpsTable_project$ref = any;
export type httpStatus_HttpStatusCategory_HttpWithinHttpsTable_QueryVariables = {|
  host: string
|};
export type httpStatus_HttpStatusCategory_HttpWithinHttpsTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: HttpWithinHttpsTable_project$ref
  |}
|};
export type httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query = {|
  variables: httpStatus_HttpStatusCategory_HttpWithinHttpsTable_QueryVariables,
  response: httpStatus_HttpStatusCategory_HttpWithinHttpsTable_QueryResponse,
|};
*/


/*
query httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...HttpWithinHttpsTable_project
    id
  }
}

fragment HttpWithinHttpsTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesHttpInHttps(assetTypeFilters: ["img", "js", "css", "misc"], assetUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          type
          severity
          count
        }
        httpInHttps(offset: 0, limit: 20, typeFilters: [], assetTypeFilters: ["img", "js", "css", "misc"], assetUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...HttpWithinHttpsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment HttpWithinHttpsRow_issue on HttpInHttps {
  id
  type
  severity
  asset_count
  asset_types
  asset_urls
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "kind": "Literal",
  "name": "assetTypeFilters",
  "value": [
    "img",
    "js",
    "css",
    "misc"
  ],
  "type": "[String]"
},
v4 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v5 = {
  "kind": "Literal",
  "name": "assetUrl",
  "value": v4,
  "type": "TextFilters"
},
v6 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v4,
  "type": "TextFilters"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query",
  "id": null,
  "text": "query httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...HttpWithinHttpsTable_project\n    id\n  }\n}\n\nfragment HttpWithinHttpsTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesHttpInHttps(assetTypeFilters: [\"img\", \"js\", \"css\", \"misc\"], assetUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          type\n          severity\n          count\n        }\n        httpInHttps(offset: 0, limit: 20, typeFilters: [], assetTypeFilters: [\"img\", \"js\", \"css\", \"misc\"], assetUrl: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...HttpWithinHttpsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment HttpWithinHttpsRow_issue on HttpInHttps {\n  id\n  type\n  severity\n  asset_count\n  asset_types\n  asset_urls\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HttpWithinHttpsTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesHttpInHttps",
                        "storageKey": "countTypesHttpInHttps(assetTypeFilters:[\"img\",\"js\",\"css\",\"misc\"],assetUrl:{\"operator\":\"AND\",\"values\":[]},sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v3,
                          v5,
                          v6
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v7,
                          v8,
                          v9
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "httpInHttps",
                        "storageKey": "httpInHttps(assetTypeFilters:[\"img\",\"js\",\"css\",\"misc\"],assetUrl:{\"operator\":\"AND\",\"values\":[]},limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]},typeFilters:[])",
                        "args": [
                          v3,
                          v5,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          v6,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "HttpInHttpssConnection",
                        "plural": false,
                        "selections": [
                          v9,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "HttpInHttpssEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "HttpInHttps",
                                "plural": false,
                                "selections": [
                                  v10,
                                  v7,
                                  v8,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "asset_count",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "asset_types",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "asset_urls",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v10
                    ]
                  }
                ]
              }
            ]
          },
          v10
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c92428e130bb37bf392485ebdb0c6897';
module.exports = node;
